/**
 * Name: vb-ui-progress-bar
 * Example:
 * <vb-ui-progress-bar
 *		label="instance.name"
 *		progress="instance.progress">
 * </vb-ui-progress-bar>
*/

import {
	Component,
	Input,
	OnInit
} from '@angular/core';

import styles from './progress-bar.module.less';

const DEFAULT_PROGRESS_MAX: number = 100;

@Component({
	selector: 'vb-ui-progress-bar',
	templateUrl: './VbUiProgressBar.Component.html'
})
export class VbUiProgressBarComponent implements OnInit {
	@Input() public label: string;
	@Input() public progress: number;
	@Input() public max: number;
	@Input() public mini: boolean;

	public readonly styles = styles;

	public ngOnInit(): void {
		this.max = this.max || DEFAULT_PROGRESS_MAX;
	}

	public get progressPercentage(): number {
		const progress: number = this.progress || 0;

		return progress / this.max * 100;
	}
}
